// eslint-disable-next-line import/order
import $ from "jquery";

import "jquery-validation";
import "jquery-validation-unobtrusive";
import "jquery-countdown";
import "bootstrap";
import "bootstrap-datepicker";
import "slick-carousel";

import "tinymce";
import "tinymce/icons/default";
import "tinymce/models/dom";
import "tinymce/skins/content/default/content.js";
import "tinymce/skins/ui/oxide/content.js";
import "tinymce/skins/ui/oxide/skin.js";
import "tinymce/themes/silver";

import { frontend } from "widgets-module/app";

window.$ = window.jQuery = $;

$(() => frontend.init());
